module.exports = __webpack_public_path__ + "static/assets/ba1b591aa3b2c3a2a6bce38958487faa.png";